import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, ButtonGroup, Col, Container, Image, ListGroup, Row, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Thumb from './common/Thumb';
import { LoginInfo } from '../App';
import { t } from 'i18next';
import { imageUrl } from '../service/CommonUtil';
import UserMark from './UserMark';
import Constants from './common/Constants';
import FavoriteIconMui from '@mui/icons-material/Favorite';

const Notice = () => {
    async function getNoticeList(page,div){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/notice/"+page,{div:div}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const location = useLocation()
    const param = useParams()
    const {t} = useTranslation()

    // ナビゲート
    const navigate = useNavigate()

    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    let s = localStorage
    const [searchPage,setSearchPage] = useState(param.page === undefined ? 1 : parseInt(param.page))
    const [noticeList,setNoticeList] = useState([])
    const [radioDiv1,setRadioDiv1] = useState(s.getItem("d1") === "true" || false)
    const [radioDiv2,setRadioDiv2] = useState(s.getItem("d2") === "true" || false)
    const [radioDiv3,setRadioDiv3] = useState(s.getItem("d3") === "true" || false)
    const [radioDiv4,setRadioDiv4] = useState(s.getItem("d4") === "true" || false)
    const [radioDiv5,setRadioDiv5] = useState(s.getItem("d5") === "true" || false)
    const [radioDiv6,setRadioDiv6] = useState(s.getItem("d6") === "true" || false)
    const [radioDiv7,setRadioDiv7] = useState(s.getItem("d7") === "true" || false)

    const div = [
        { name: t("common.like"), value: 1,checked:radioDiv1,set:setRadioDiv1 },
        { name: t("common.follow"), value: 2,checked:radioDiv2,set:setRadioDiv2 },
        { name: t("common.comment"), value: 3,checked:radioDiv3,set:setRadioDiv3 },
        { name: t("common.reply"), value: 4,checked:radioDiv4,set:setRadioDiv4 },
        { name: t("category.ranking"), value: 5,checked:radioDiv5,set:setRadioDiv5 },
        { name: t("common.awardingPoints"), value: 6,checked:radioDiv6,set:setRadioDiv6 },
        { name: t("common.others"), value: 7,checked:radioDiv7,set:setRadioDiv7 }
    ]

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    useEffect(() => {
        getNoticeList(searchPage,div).then(r => {
            if(r.result){
                setNoticeList(r.data)
            } else {
                dialog(t("common.error"),r.errors)
            }
        })
        let s = localStorage
        let list = [radioDiv1,radioDiv2,radioDiv3,radioDiv4,radioDiv5,radioDiv6,radioDiv7]
        list.forEach((v,i) => s.setItem("d"+(i+1),v))
            console.log(1)
    },[searchPage,radioDiv1,radioDiv2,radioDiv3,radioDiv4,radioDiv5,radioDiv6,radioDiv7])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
            <Container>
                <ButtonGroup className="mb-2">
                    {div.map((radio, idx) => {
                        if(idx > 3) return ""
                        return (
                        <ToggleButton
                            key={idx}
                            id={`div-${idx}`}
                            type="radio"
                            variant={'outline-primary'}
                            name={`div-${idx}`}
                            value={radio.value}
                            checked={div[radio.value - 1].checked}
                            onClick={(e) => {
                                div[radio.value - 1].set(!div[radio.value - 1].checked)
                            }}
                            >
                            {radio.name}
                        </ToggleButton>)
                    })}
                </ButtonGroup>
                &nbsp;
                <ButtonGroup className="mb-2">
                    {div.map((radio, idx) => {
                        if(idx < 4) return ""
                        return (
                        <ToggleButton
                            key={idx}
                            id={`div-${idx}`}
                            type="radio"
                            variant={'outline-primary'}
                            name={`div-${idx}`}
                            value={radio.value}
                            checked={div[radio.value - 1].checked}
                            onClick={(e) => {
                                div[radio.value - 1].set(!div[radio.value - 1].checked)
                            }}
                            >
                            {radio.name}
                        </ToggleButton>)
                    })}
                </ButtonGroup>
            </Container>
            <Container>
            <ListGroup>
                {noticeList.map((d,i)=>{
                    let link
                    if(d.type==="follow"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#fff8f0", borderLeft: "4px solid #f6ad55"}}>
                                <LinkContainer to={"/user/"+d.user_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Link to={"/user/"+d.user_id}>
                                            <Container style={{width:"50px", position: "relative", display: "flex", alignItems: "center"}}>
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" />
                                                <Icon.PersonPlus style={{position: "absolute", bottom: "-5px", right: "-5px", backgroundColor: "white", borderRadius: "50%", padding: "2px", fontSize: "16px", color: "#f6ad55"}} />
                                                {d.title}
                                            </Container>
                                        </Link>
                                        <Container>
                                            <Container>{t("notice.followedLeftText")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.followedRightText")}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "favorite_image" || d.type === "favorite_text"){
                        let type = d.type.startsWith("favorite_image") ? "image" : "text"
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#fff5f5", borderLeft: "4px solid #f56565"}}>
                                <LinkContainer to={"/"+type+"/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Link to={"/user/"+d.user_id}>
                                            <Container style={{width:"50px", position: "relative", display: "flex", alignItems: "center"}}>
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" />
                                                <Icon.Heart style={{position: "absolute", bottom: "-5px", right: "-5px", backgroundColor: "white", borderRadius: "50%", padding: "2px", fontSize: "16px", color: "#f56565"}} />
                                            </Container>
                                        </Link>
                                        <Container>
                                            <Container>{t("notice.favoriteLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.favoriteCenter")}「<b>{d.title}</b>」{t("notice.favoriteRight")}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "favorite_community"){
                        link = 
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#fff5f5", borderLeft: "4px solid #f56565"}}>
                                <LinkContainer to={"/post/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Link to={"/user/"+d.user_id}>
                                            <Container style={{width:"50px", position: "relative", display: "flex", alignItems: "center"}}>
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" />
                                                <Icon.Heart style={{position: "absolute", bottom: "-5px", right: "-5px", backgroundColor: "white", borderRadius: "50%", padding: "2px", fontSize: "16px", color: "#f56565"}} />
                                            </Container>
                                        </Link>
                                        <Container>
                                            <Container>{t("notice.favoriteLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.favoriteCenter")}「<b>{d.title}</b>」{t("notice.favoriteRight")}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "image_reply"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0f8ff", borderLeft: "4px solid #4a90e2"}}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Link to={(d.comment === "is_character" ? "/character/" : "/user/") + d.user_id}>
                                            <Container style={{width:"50px", position: "relative", display: "flex", alignItems: "center"}}>
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+(d.comment === "is_character" ? ("/character/post/t/"+d.user_id+"_in.webp") : ("/profile/"+d.user_id+"_s.jpg"))} className="noticeLazy" />
                                                <Icon.ChatDots style={{position: "absolute", bottom: "-5px", right: "-5px", backgroundColor: "white", borderRadius: "50%", padding: "2px", fontSize: "16px", color: "#4a90e2"}} />
                                            </Container>
                                        </Link>
                                        <Container>
                                            <Container>{t("notice.commentLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.commentCenter")}「<b>{d.title}</b>」{t("notice.commentRight")}</Container>
                                            {d.comment.length > 0 && d.comment !== "is_character" ? <Container>「{d.comment}」</Container> : ""}
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "image_reply_sub"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0f8ff", borderLeft: "4px solid #4a90e2"}}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Link to={(d.comment === "is_character" ? "/character/" : "/user/") + d.user_id}>
                                            <Container style={{width:"50px", position: "relative", display: "flex", alignItems: "center"}}>
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+(d.comment === "is_character" ? ("/character/post/t/"+d.user_id+"_in.webp") : ("/profile/"+d.user_id+"_s.jpg"))} className="noticeLazy" />
                                                <Icon.ChatDots style={{position: "absolute", bottom: "-5px", right: "-5px", backgroundColor: "white", borderRadius: "50%", padding: "2px", fontSize: "16px", color: "#4a90e2"}} />
                                            </Container>
                                        </Link>
                                        <Container>
                                            <Container>{t("notice.commentSubLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.commentSubCenter")}「<b>{d.title}</b>」{t("notice.commentSubRight")}</Container>
                                            {d.comment.length > 0 && d.comment !== "is_character" ? <Container>「{d.comment}」</Container> : ""}
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "community_reply"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0f8ff", borderLeft: "4px solid #4a90e2"}}>
                                <LinkContainer to={"/post/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Link to={"/user/"+d.user_id}>
                                            <Container style={{width:"50px", position: "relative", display: "flex", alignItems: "center"}}>
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" />
                                                <Icon.ChatDots style={{position: "absolute", bottom: "-5px", right: "-5px", backgroundColor: "white", borderRadius: "50%", padding: "2px", fontSize: "16px", color: "#4a90e2"}} />
                                            </Container>
                                        </Link>
                                        <Container>
                                            <Container>{t("notice.commentLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.commentCenter")}「<b>{d.title}</b>」{t("notice.commentRight")}</Container>
                                            {d.comment.length > 0 ? <Container>「{d.comment}」</Container> : ""}
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "ranking"){
                        let styles = [t("common.illustration"),t("common.photorealistic"),t("common.semirealism")]
                        let styleParams = ["illustration","photorealistic","semirealism"]
                        let categoryList = [t("common.allAges"),"PG-12","R-18","R-18G",t("common.all")]
                        let categoryParams = {"allAges":t("common.allAges"),"pg12":"PG-12","r15":"R-15","r18":"R-18","r18g":"R-18G","all":"総合"}
                        let typeList = ["すべて","お題","お題除外"]
                        let typeParams = ["s_all","s_odai","s_jogai"]
                        let styleNo = 0
                        let general = ""
                        let age = ""
                        let typeNo = 0
                        let typeStr = ""
                        let rankStr = ""
                        if(d.comment.indexOf(",") !== -1){
                            let spl = d.comment.split(",")
                            typeNo = parseInt(spl[1]) -1
                            typeStr = typeList[typeNo]
                            rankStr = spl[0]
                        } else {
                            typeStr = typeList[0]
                            rankStr = d.comment
                        }
                        if(d.user_name.indexOf(":") !== -1){
                            let spl = d.user_name.split(":")
                            styleNo = parseInt(spl[0]) - 1
                            general = spl[1]
                        } else {
                            styleNo = 1
                            general = d.user_name
                        }
                        if(general === "all"){
                            age = "総合"
                        }
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/ranking/"+styleParams[styleNo]+"/"+general.replace("allAges","all")+"/1day/"+typeParams[typeNo]+"/1"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in.webp"} className="noticeLazy" /></Container>
                                        <Container>
                                            <Container>{t("notice.rankingLeft")}「{d.title}」{t("notice.rankingCenter")}<b>{rankStr}</b>{t("notice.rankingRight")}</Container>
                                            <Container>{typeStr} {styles[styleNo]} {categoryParams[general]} {d.ymd}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "age_limit_alert"){
                        let ageLimitList = [t("common.allAges"),"PG-12","R-15","R-18","R-18G",t("common.all")]
                        let sexualExpressionList = [t("upload.image.whatIsSexual"),""]
                        let spl = d.comment.split("->")
                        let oldSpl = spl[0].split(",")
                        let newSpl = spl[1].split(",")
                        let oldAgeLimit = oldSpl[0]
                        let oldSexualExpression = oldSpl[1]
                        let newAgeLimit = newSpl[0] - 1
                        let newSexualExpression = newSpl[1]
                        console.log(oldAgeLimit,oldSexualExpression,newAgeLimit,newSexualExpression)

                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in.webp"} className="noticeLazy" /></Container>
                                        <Container>
                                            <Container style={{color:"red"}}>{t("notice.ageLimitAlert")}</Container>
                                            <Container>「{d.title}」</Container>
                                            <Container>{ageLimitList[newAgeLimit]}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "mosaic_alert" || d.type === "child_porn_alert"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}><Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in.webp"} className="noticeLazy" /></Container>
                                        <Container>
                                            <Container style={{color:"red"}}>{d.type === "mosaic_alert" ? t("notice.mosaicAlert") : t("notice.childPornAlert")}</Container>
                                            <Container>「{d.title}」</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "problem_result"){
                        // 再公開
                        if(d.user_name === "1"){
                            link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/"+d.comment+"/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}>
                                            {d.comment === "video" ? (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id,"status":5},d.comment)} className="noticeLazy" />
                                            ) : (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id},d.comment)} className="noticeLazy" />
                                            )}
                                        </Container>
                                        <Container>
                                            <Container style={{color:"green"}}><Icon.CheckCircle /> 審査の結果、再公開されました。</Container>
                                            <Container>「{d.title}」</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                        } else if(d.user_name === "2"){
                            // 差し戻し
                            link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/"+d.comment+"/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container style={{width:"50px"}}>
                                            {d.comment === "video" ? (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id,"status":5},d.comment)} className="noticeLazy" />
                                            ) : (
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"5px"}} src={imageUrl({"group_id":d.group_id},d.comment)} className="noticeLazy" />
                                            )}
                                        </Container>
                                        <Container>
                                            <Container style={{color:"red"}}><Icon.XCircle /> 審査の結果、差し戻されました：{d.user_name === "1" ? t("notice.mosaicAlert") : t("notice.childPornAlert")}</Container>
                                            <Container>「{d.title}」</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                        }
                    } else if(d.type === "point_send"){
                        link =
                            <ListGroup.Item className="p-0" key={i} style={{backgroundColor: "#f0fff0", borderLeft: "4px solid #28a745"}}>
                                <LinkContainer to={"/user/"+d.user_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Link to={"/user/"+d.user_id}>
                                            <Container style={{width:"50px", position: "relative", display: "flex", alignItems: "center"}}>
                                                <Image data-no={i} loading="lazy" style={{width:"50px",height:"50px",borderRadius:"25px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} className="noticeLazy" />
                                                <Icon.Gift style={{position: "absolute", bottom: "-5px", right: "-5px", backgroundColor: "white", borderRadius: "50%", padding: "2px", fontSize: "16px", color: "#28a745"}} />
                                            </Container>
                                        </Link>
                                        <Container>
                                            <Container>{t("notice.pointSendLeft")}<ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby><UserMark plan={d.plan}/>{t("notice.pointSendRight")}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "report"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/siteManage"} className="list-item p-1" style={{color:"red"}}>
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>新しい通報がありました。内容を確認してください。</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "monetization"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <Container className="d-flex p-0">
                                    <Container>
                                        <Container>🎉収益が送金されました。+{d.comment} 円</Container>
                                        <Container>{d.create_datetime}</Container>
                                    </Container>
                                </Container>
                            </ListGroup.Item>
                    } else if(d.type === "outside_id_link_world_id"){
                        let point = parseInt(d.comment).toLocaleString()
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <Container className="d-flex p-0">
                                    <Container>
                                        <Container>🎉World ID連携ボーナスの生成ポイントが付与されました。+{point} ポイント</Container>
                                        <Container>{d.create_datetime}</Container>
                                    </Container>
                                </Container>
                            </ListGroup.Item>
                    } else if(d.type === "coinCharge"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <Container className="d-flex p-0">
                                    <Container>
                                        <Container>コインがチャージされました。 {Constants.CURRENCY_UNIT_LEFT_COIN} {parseInt(d.comment).toLocaleString()}</Container>
                                        <Container>{d.create_datetime}</Container>
                                    </Container>
                                </Container>
                            </ListGroup.Item>
                    } else if(d.type === "id_regist"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/manage/id"} className="list-item p-1" style={{color:d.comment !== "" ? "red" : ""}}>
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>{d.comment === "" ? "身分証確認が完了しました。" : "身分証確認が差し戻されました。"}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "fanart"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/image/"+d.group_id} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        {/*<Container style={{width:"75px",height:"75px",overflow:"hidden"}}><Image data-no={i} loading="lazy" style={{width:"75px",height:"75px",filter:"blur(10px)"}} src={"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in.webp"} className="noticeLazy" /></Container>*/}
                                        <FavoriteIconMui style={{color:"red"}} />
                                        <Container>
                                            <Container>「{d.title}」</Container>
                                            <Container>{t("common.fanartPosted")}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "dividend"){
                        let point = parseInt(d.comment).toLocaleString()
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/pointHistory/"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>🎉ポイント運用で配当がありました。</Container>
                                            <Container>配当額：{point} ポイント</Container>
                                            <Container>銘柄：{d.title}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "zero_point_campaign"){
                        let point = parseInt(d.comment).toLocaleString()
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/pointHistory/"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>🎉キャンペーン参加特典が付与されました。</Container>
                                            <Container>{point} ポイント</Container>
                                            <Container>{d.title}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    } else if(d.type === "rewards_delivery"){
                        link =
                            <ListGroup.Item className="p-0" key={i}>
                                <LinkContainer to={"/rewardsHistory/"} className="list-item p-1">
                                    <Container className="d-flex p-0">
                                        <Container>
                                            <Container>🎉{d.title}</Container>
                                            <Container>{d.comment}</Container>
                                            <Container>{d.create_datetime}</Container>
                                        </Container>
                                    </Container>
                                </LinkContainer>
                            </ListGroup.Item>
                    }
                    return link
                })}
            </ListGroup>
            </Container>
            <Container className='d-flex justify-content-between mt-3' style={{width:"200px"}}>
            {searchPage > 1 ? (
                    <Button onClick={() => {
                        let page = searchPage - 1
                        setSearchPage(page)
                        navigate("/notice/"+page)
                    } }>{t("common.prev")}</Button>
                ) : <Button disabled>{t("common.prev")}</Button>}
            {noticeList.length > 99 ? (
                    <Button onClick={() => {
                        let page = searchPage + 1
                        setSearchPage(page)
                        navigate("/notice/"+page)
                    } }>{t("common.next")}</Button>
                ) : <Button disabled>{t("common.next")}</Button>}
            </Container>
        <Footer />
    </div>
    )
}

export default Notice;
